(() => {
  const leadingQuotes = /^[\s"'“”‘’]+/;
  const trailingQuotes = /["'“”‘’]+\s*$/;

  document
    .querySelectorAll(".customer-testimonial-block .content")
    .forEach((el) => {
      const cleaned = el.textContent
        .replace(leadingQuotes, "")
        .replace(trailingQuotes, "")
        .trim();
      el.textContent = cleaned;
    });
})();
